import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=2a5ddf27&scoped=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./ProfileEdit.vue?vue&type=style&index=0&id=2a5ddf27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5ddf27",
  null
  
)

export default component.exports